import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { isEqual, MarketplaceItemMappingAttribute, MemberQuery, MarketplaceExtendedQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@fgb/core';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@ngx-translate/core';

function MarketplaceAttributesComponent_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵlistener("click", function MarketplaceAttributesComponent_div_1_ng_container_3_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); const _r1 = ɵngcc0.ɵɵreference(3); return ctx_r8.open(_r1); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    const i_r4 = ctx_r10.index;
    const attribute_r3 = ctx_r10.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "attr", i_r4, "-select");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(3, 3, "marketplace.attribute.button"), " ", attribute_r3.DisplayName, " ");
} }
function MarketplaceAttributesComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵlistener("click", function MarketplaceAttributesComponent_div_1_ng_container_4_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); const _r1 = ɵngcc0.ɵɵreference(3); return ctx_r11.open(_r1); });
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const attribute_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", attribute_r3.DisplayName, " ", ctx_r6.selectedAttributeValue.DisplayName, "");
} }
function MarketplaceAttributesComponent_div_1_div_5_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵelementStart(2, "input", 14);
    ɵngcc0.ɵɵlistener("change", function MarketplaceAttributesComponent_div_1_div_5_ng_container_1_div_1_Template_input_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const attribute_r3 = ɵngcc0.ɵɵnextContext(3).$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onAttributeValueChange(attribute_r3, $event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 15);
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r15 = ɵngcc0.ɵɵnextContext().$implicit;
    const i_r4 = ɵngcc0.ɵɵnextContext(2).index;
    const ctx_r17 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("id", "attr" + i_r4)("checked", ctx_r17.selectedValues[i_r4] == value_r15.RewardValueId)("value", value_r15.RewardValueId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r17.selectedValues[i_r4] == value_r15.RewardValueId ? "btn-selected-attribute" : "btn-non-selected-attribute");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", value_r15.DisplayName, " ");
} }
function MarketplaceAttributesComponent_div_1_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MarketplaceAttributesComponent_div_1_div_5_ng_container_1_div_1_Template, 6, 5, "div", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const avi_r16 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", avi_r16 < 5);
} }
function MarketplaceAttributesComponent_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, MarketplaceAttributesComponent_div_1_div_5_ng_container_1_Template, 2, 1, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", attribute_r3.Values)("ngForTrackBy", ctx_r7.identify);
} }
function MarketplaceAttributesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵtemplate(3, MarketplaceAttributesComponent_div_1_ng_container_3_Template, 4, 5, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(4, MarketplaceAttributesComponent_div_1_ng_container_4_Template, 4, 2, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, MarketplaceAttributesComponent_div_1_div_5_Template, 2, 2, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("id", "attr", i_r4, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.selectedAttributeValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedAttributeValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showFirstFiveAttributes);
} }
function MarketplaceAttributesComponent_ng_template_2_div_4_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 27);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵelementStart(3, "input", 14);
    ɵngcc0.ɵɵlistener("change", function MarketplaceAttributesComponent_ng_template_2_div_4_ng_container_7_Template_input_change_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const attribute_r26 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ctx_r30.onAttributeValueChange(attribute_r26, $event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 28);
    ɵngcc0.ɵɵlistener("click", function MarketplaceAttributesComponent_ng_template_2_div_4_ng_container_7_Template_div_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r33 = ɵngcc0.ɵɵnextContext(3); return ctx_r33.closeModal(); });
    ɵngcc0.ɵɵelementStart(5, "div", 16);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const value_r29 = ctx.$implicit;
    const i_r27 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r28 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("id", "attr" + i_r27)("checked", ctx_r28.selectedValues[i_r27] == value_r29.RewardValueId)("value", value_r29.RewardValueId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r28.selectedValues[i_r27] == value_r29.RewardValueId ? "btn-selected-attribute" : "btn-non-selected-attribute");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", value_r29.DisplayName, " ");
} }
function MarketplaceAttributesComponent_ng_template_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "div", 23);
    ɵngcc0.ɵɵelementStart(2, "div", 24);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 25);
    ɵngcc0.ɵɵelementStart(6, "div");
    ɵngcc0.ɵɵtemplate(7, MarketplaceAttributesComponent_ng_template_2_div_4_ng_container_7_Template, 7, 5, "ng-container", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r26 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(4, 3, "marketplace.attribute.title"), " ", attribute_r26.DisplayName, "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", attribute_r26.Values);
} }
function MarketplaceAttributesComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵelementStart(2, "div", 19);
    ɵngcc0.ɵɵlistener("click", function MarketplaceAttributesComponent_ng_template_2_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(); return ctx_r35.closeModal(); });
    ɵngcc0.ɵɵelement(3, "div", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, MarketplaceAttributesComponent_ng_template_2_div_4_Template, 8, 5, "div", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.localisedAttributes);
} }
class MarketplaceAttributesComponent {
    constructor(modalService, memberQuery, marketplaceExtendedQuery) {
        this.modalService = modalService;
        this.memberQuery = memberQuery;
        this.marketplaceExtendedQuery = marketplaceExtendedQuery;
        this.attributeMapping = new EventEmitter();
        this.selectedValues = [];
        this.showFirstFiveAttributes = false;
        this._destroyed$ = new Subject();
    }
    ngOnInit() {
        if (this.marketplaceItem.Attributes && this.marketplaceItem.Attributes.length) {
            this.getLocalAttributes();
            this.setupMapping();
        }
    }
    identify(index, item) {
        return item.DisplayName;
    }
    getLocalAttributes() {
        this.memberQuery.userContext$
            .pipe(takeUntil(this._destroyed$), map((user) => {
            if (user && user.lcid) {
                this.localisedAttributes = this.marketplaceExtendedQuery.getLocalisedAttributes(this.marketplaceItem.Id, +user.lcid);
            }
            else {
                this.localisedAttributes = this.marketplaceItem.Attributes;
            }
        }))
            .subscribe();
    }
    setupMapping() {
        this._emitMapping();
    }
    onAttributeValueChange(attribute, valueId) {
        this.selectedAttributeValue = attribute.Values.find((x) => x.RewardValueId === +valueId);
        // remove the previous attribute value
        this.selectedValues = this.selectedValues.filter((i) => !attribute.Values.some((x) => x.RewardValueId === i));
        // add the new value
        this.selectedValues.push(+valueId);
        this._emitMapping();
    }
    _emitMapping() {
        let matchingMapping = this.marketplaceItem.AttributeMappings.find((x) => isEqual(x.AttributeValues, this.selectedValues, true));
        let newMapping;
        if (matchingMapping) {
            newMapping = matchingMapping;
        }
        else {
            newMapping = new MarketplaceItemMappingAttribute();
            newMapping.AvailableStockCount = 0;
            newMapping.StockCount = 0;
        }
        this.attributeMapping.emit(newMapping);
    }
    open(content) {
        this.modalService.open(content, { size: 'lg' });
    }
    closeModal() {
        this.modalService.dismissAll();
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
MarketplaceAttributesComponent.ɵfac = function MarketplaceAttributesComponent_Factory(t) { return new (t || MarketplaceAttributesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MemberQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MarketplaceExtendedQuery)); };
MarketplaceAttributesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MarketplaceAttributesComponent, selectors: [["fgbcl-marketplace-attributes"]], inputs: { marketplaceItem: "marketplaceItem" }, outputs: { attributeMapping: "attributeMapping" }, decls: 4, vars: 1, consts: [[1, "container", "p-0", "marketplace-attribute"], ["class", "mb-4 attribute-control", 3, "id", 4, "ngFor", "ngForOf"], ["selectAttributesModal", ""], [1, "mb-4", "attribute-control", 3, "id"], [1, "row", "my-3"], [1, "col-12"], [4, "ngIf"], ["class", "col-10", 4, "ngIf"], [1, "select-attribute-modal-btn", "btn-attribute", "rounded", 3, "id", "click"], [1, "select-attribute-modal-btn", "selected-attribute", "btn-attribute-selected", "px-3", "rounded", "text-center", 3, "click"], [1, "col-10"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "attribute-container d-inline-flex mb-3", 4, "ngIf"], [1, "attribute-container", "d-inline-flex", "mb-3"], ["type", "radio", "name", "attribute.RewardValueId", 1, "card-input-element", "d-none", 3, "id", "checked", "value", "change"], [1, "attribute-box", "btn", "border-disabled", "rounded", 3, "ngClass"], [1, "attribute-display-name"], [1, "modal-content", "marketplace-attribute-modal"], [1, "modal-body", "text-center", "p-2"], [1, "close-modal", "position", "absolute", "float-right", "text-primary", 3, "click"], [1, "icon", "icon-cancel-circle"], ["class", "mb-4", "id", "attributes-container", 4, "ngFor", "ngForOf"], ["id", "attributes-container", 1, "mb-4"], [1, "modal-header", "d-block", "text-center", "border-bottom-0"], [1, "attributes-modal-title"], [1, "my-3"], [4, "ngFor", "ngForOf"], [1, "attribute-container", "d-inline-flex", "justify-content-center", "align-items-center", "mb-3"], [1, "attribute-box", "btn", "border-disabled", "rounded", 3, "ngClass", "click"]], template: function MarketplaceAttributesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MarketplaceAttributesComponent_div_1_Template, 6, 4, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, MarketplaceAttributesComponent_ng_template_2_Template, 5, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.localisedAttributes);
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc3.NgClass], pipes: [ɵngcc4.TranslatePipe], styles: [".marketplace-attribute[_ngcontent-%COMP%]   .attribute-container[_ngcontent-%COMP%]{width:20%}.marketplace-attribute[_ngcontent-%COMP%]   .attribute-container[_ngcontent-%COMP%]   .attribute-box[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;height:60px;width:80px}.marketplace-attribute[_ngcontent-%COMP%]   .select-attribute-modal-btn[_ngcontent-%COMP%]{width:142px;height:40px;display:flex;align-items:center;justify-content:center}.marketplace-attribute[_ngcontent-%COMP%]   .select-attribute-modal-btn.selected-attribute[_ngcontent-%COMP%]{width:280px}@media (max-width:991px){.marketplace-attribute[_ngcontent-%COMP%]   .select-attribute-modal-btn[_ngcontent-%COMP%], .marketplace-attribute[_ngcontent-%COMP%]   .select-attribute-modal-btn.selected-attribute[_ngcontent-%COMP%]{width:100%}}.marketplace-attribute-modal[_ngcontent-%COMP%]   .close-modal[_ngcontent-%COMP%]{top:10px;right:10px;font-size:20px}.marketplace-attribute-modal[_ngcontent-%COMP%]   .attribute-container[_ngcontent-%COMP%]{width:50%}@media (max-width:991px){.marketplace-attribute-modal[_ngcontent-%COMP%]   .attribute-container[_ngcontent-%COMP%]{width:100%}}.marketplace-attribute-modal[_ngcontent-%COMP%]   .attribute-container[_ngcontent-%COMP%]   .attribute-box[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;height:40px;width:280px}.marketplace-attribute-modal[_ngcontent-%COMP%]   .select-attribute-modal-btn[_ngcontent-%COMP%]{width:142px;height:40px;display:flex;align-items:center;justify-content:center}"] });
MarketplaceAttributesComponent.ctorParameters = () => [
    { type: NgbModal },
    { type: MemberQuery },
    { type: MarketplaceExtendedQuery }
];
MarketplaceAttributesComponent.propDecorators = {
    marketplaceItem: [{ type: Input }],
    attributeMapping: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceAttributesComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-marketplace-attributes',
                template: "<!--Main Body-->\r\n<div class=\"container p-0 marketplace-attribute\">\r\n  <!-- <hr class=\"border-top border-disabled mt-0 mb-2 w-100\" /> -->\r\n  <div *ngFor=\"let attribute of localisedAttributes; let i = index\" class=\"mb-4 attribute-control\" id=\"attr{{ i }}\">\r\n    <!-- <label [for]=\"'attr' + i\" class=\"attributes-title mt-3 mb-0\"\r\n      >{{ 'marketplace.attribute.title' | translate }} {{ attribute.DisplayName }}</label\r\n    > -->\r\n    <div class=\"row my-3\">\r\n      <div class=\"col-12\">\r\n        <ng-container *ngIf=\"!selectedAttributeValue\">\r\n          <div\r\n            class=\"select-attribute-modal-btn btn-attribute rounded\"\r\n            (click)=\"open(selectAttributesModal)\"\r\n            id=\"attr{{ i }}-select\"\r\n          >\r\n            {{ 'marketplace.attribute.button' | translate }} {{ attribute.DisplayName }}\r\n          </div>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"selectedAttributeValue\">\r\n          <div\r\n            class=\"select-attribute-modal-btn selected-attribute btn-attribute-selected px-3 rounded text-center\"\r\n            (click)=\"open(selectAttributesModal)\"\r\n          >\r\n            <div>{{ attribute.DisplayName }} {{ selectedAttributeValue.DisplayName }}</div>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n      <!--Show First Five Attributes (Not Showing ATM)-->\r\n      <div class=\"col-10\" *ngIf=\"showFirstFiveAttributes\">\r\n        <ng-container *ngFor=\"let value of attribute.Values; index as avi; trackBy: identify\">\r\n          <div class=\"attribute-container d-inline-flex mb-3\" *ngIf=\"avi < 5\">\r\n            <label>\r\n              <input\r\n                type=\"radio\"\r\n                [id]=\"'attr' + i\"\r\n                (change)=\"onAttributeValueChange(attribute, $event.target.value)\"\r\n                name=\"attribute.RewardValueId\"\r\n                class=\"card-input-element d-none\"\r\n                [checked]=\"selectedValues[i] == value.RewardValueId\"\r\n                [value]=\"value.RewardValueId\"\r\n              />\r\n              <div\r\n                class=\"attribute-box btn border-disabled rounded\"\r\n                [ngClass]=\"selectedValues[i] == value.RewardValueId ? 'btn-selected-attribute' : 'btn-non-selected-attribute'\"\r\n              >\r\n                <div class=\"attribute-display-name\">\r\n                  {{ value.DisplayName }}\r\n                </div>\r\n              </div>\r\n            </label>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- <hr class=\"border-top border-disabled mt-2 mb-2 w-100\" /> -->\r\n</div>\r\n\r\n<!--Modal-->\r\n<ng-template #selectAttributesModal let-modal>\r\n  <div class=\"modal-content marketplace-attribute-modal\">\r\n    <div class=\"modal-body text-center p-2\">\r\n      <div class=\"close-modal position absolute float-right text-primary\" (click)=\"closeModal()\">\r\n        <div class=\"icon icon-cancel-circle\"></div>\r\n      </div>\r\n      <div *ngFor=\"let attribute of localisedAttributes; let i = index\" class=\"mb-4\" id=\"attributes-container\">\r\n        <div class=\"modal-header d-block text-center border-bottom-0\">\r\n          <div class=\"attributes-modal-title\">{{ 'marketplace.attribute.title' | translate }} {{ attribute.DisplayName }}</div>\r\n        </div>\r\n        <div class=\"my-3\">\r\n          <div>\r\n            <ng-container *ngFor=\"let value of attribute.Values\">\r\n              <div class=\"attribute-container d-inline-flex justify-content-center align-items-center mb-3\">\r\n                <label>\r\n                  <input\r\n                    type=\"radio\"\r\n                    [id]=\"'attr' + i\"\r\n                    (change)=\"onAttributeValueChange(attribute, $event.target.value)\"\r\n                    name=\"attribute.RewardValueId\"\r\n                    class=\"card-input-element d-none\"\r\n                    [checked]=\"selectedValues[i] == value.RewardValueId\"\r\n                    [value]=\"value.RewardValueId\"\r\n                  />\r\n                  <div\r\n                    class=\"attribute-box btn border-disabled rounded\"\r\n                    [ngClass]=\"selectedValues[i] == value.RewardValueId ? 'btn-selected-attribute' : 'btn-non-selected-attribute'\"\r\n                    (click)=\"closeModal()\"\r\n                  >\r\n                    <div class=\"attribute-display-name\">\r\n                      {{ value.DisplayName }}\r\n                    </div>\r\n                  </div>\r\n                </label>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [".marketplace-attribute .attribute-container{width:20%}.marketplace-attribute .attribute-container .attribute-box{display:flex;justify-content:center;align-items:center;height:60px;width:80px}.marketplace-attribute .select-attribute-modal-btn{width:142px;height:40px;display:flex;align-items:center;justify-content:center}.marketplace-attribute .select-attribute-modal-btn.selected-attribute{width:280px}@media (max-width:991px){.marketplace-attribute .select-attribute-modal-btn,.marketplace-attribute .select-attribute-modal-btn.selected-attribute{width:100%}}.marketplace-attribute-modal .close-modal{top:10px;right:10px;font-size:20px}.marketplace-attribute-modal .attribute-container{width:50%}@media (max-width:991px){.marketplace-attribute-modal .attribute-container{width:100%}}.marketplace-attribute-modal .attribute-container .attribute-box{display:flex;justify-content:center;align-items:center;height:40px;width:280px}.marketplace-attribute-modal .select-attribute-modal-btn{width:142px;height:40px;display:flex;align-items:center;justify-content:center}"]
            }]
    }], function () { return [{ type: ɵngcc1.NgbModal }, { type: ɵngcc2.MemberQuery }, { type: ɵngcc2.MarketplaceExtendedQuery }]; }, { attributeMapping: [{
            type: Output
        }], marketplaceItem: [{
            type: Input
        }] }); })();

class MarketplaceAttributesModule {
}
MarketplaceAttributesModule.ɵfac = function MarketplaceAttributesModule_Factory(t) { return new (t || MarketplaceAttributesModule)(); };
MarketplaceAttributesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MarketplaceAttributesModule });
MarketplaceAttributesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PipesModule,
            DirectivesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MarketplaceAttributesModule, { declarations: function () { return [MarketplaceAttributesComponent]; }, imports: function () { return [CommonModule,
        PipesModule,
        DirectivesModule, ɵngcc4.TranslateModule]; }, exports: function () { return [MarketplaceAttributesComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceAttributesModule, [{
        type: NgModule,
        args: [{
                declarations: [MarketplaceAttributesComponent],
                imports: [
                    CommonModule,
                    PipesModule,
                    DirectivesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [MarketplaceAttributesComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MarketplaceAttributesComponent, MarketplaceAttributesModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-marketplace-marketplace-details-marketplace-attributes.js.map